import React from 'react';
import { Button } from '../shadcn/button';
import { Filter, ChevronDown, CheckCircle2, X } from 'lucide-react';

const ProviderFilterDropdown = ({
  uniqueProviders,
  selectedProviders,
  providerDropdownOpen,
  setProviderDropdownOpen,
  providerDropdownRef,
  toggleProvider,
  clearProviderFilter,
}) => {
  if (uniqueProviders.length === 0) return null;

  return (
    <div className="relative" ref={providerDropdownRef}>
      <Button
        variant="outline"
        onClick={() => setProviderDropdownOpen(!providerDropdownOpen)}
        className={`h-10 text-sm border-slate-200 hover:bg-slate-50 whitespace-nowrap ${
          selectedProviders.length > 0 ? 'border-blue-300 bg-blue-50 text-blue-700' : 'text-slate-600'
        }`}
      >
        <Filter className="h-4 w-4 mr-2" strokeWidth={1.5} />
        {selectedProviders.length === 0
          ? 'All Providers'
          : selectedProviders.length === 1
            ? selectedProviders[0]
            : `${selectedProviders.length} Providers`}
        <ChevronDown className={`h-3.5 w-3.5 ml-2 transition-transform ${providerDropdownOpen ? 'rotate-180' : ''}`} strokeWidth={1.5} />
      </Button>

      {providerDropdownOpen && (
        <div className="absolute right-0 top-full mt-1 w-64 bg-white border border-slate-200 rounded-lg shadow-lg z-50 py-1">
          {/* All option */}
          <button
            onClick={clearProviderFilter}
            className={`w-full px-4 py-2 text-left text-sm flex items-center gap-2 hover:bg-slate-50 ${
              selectedProviders.length === 0 ? 'text-blue-700 font-medium' : 'text-slate-700'
            }`}
          >
            <span className={`w-4 h-4 rounded border flex items-center justify-center ${
              selectedProviders.length === 0 ? 'bg-blue-600 border-blue-600' : 'border-slate-300'
            }`}>
              {selectedProviders.length === 0 && (
                <CheckCircle2 className="h-3 w-3 text-white" strokeWidth={2.5} />
              )}
            </span>
            All Providers
          </button>
          <div className="border-t border-slate-100 my-1" />
          {/* Provider list */}
          {uniqueProviders.map(provider => (
            <button
              key={provider}
              onClick={() => toggleProvider(provider)}
              className="w-full px-4 py-2 text-left text-sm flex items-center gap-2 hover:bg-slate-50 text-slate-700"
            >
              <span className={`w-4 h-4 rounded border flex items-center justify-center ${
                selectedProviders.includes(provider) ? 'bg-blue-600 border-blue-600' : 'border-slate-300'
              }`}>
                {selectedProviders.includes(provider) && (
                  <CheckCircle2 className="h-3 w-3 text-white" strokeWidth={2.5} />
                )}
              </span>
              {provider}
            </button>
          ))}
          {/* Clear button when providers are selected */}
          {selectedProviders.length > 0 && (
            <>
              <div className="border-t border-slate-100 my-1" />
              <button
                onClick={clearProviderFilter}
                className="w-full px-4 py-2 text-left text-sm text-slate-500 hover:bg-slate-50 flex items-center gap-2"
              >
                <X className="h-3.5 w-3.5" strokeWidth={2} />
                Clear filter
              </button>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default ProviderFilterDropdown;
